import { render, staticRenderFns } from "./market-list.vue?vue&type=template&id=9ca4b4d6&scoped=true&"
import script from "./market-list.vue?vue&type=script&lang=js&"
export * from "./market-list.vue?vue&type=script&lang=js&"
import style0 from "./market-list.vue?vue&type=style&index=0&id=9ca4b4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca4b4d6",
  null
  
)

export default component.exports